/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Styles */
import styles from "./styles";

const PromotionsPageHeader = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.promotionsPageHeader}>
      <Container className={classes.container}>
        <Row>
          <Col xs={12} className="gx-0">
            <h1 className={classes.title}><FormattedMessage id="promotions.title" /></h1>
            <p className={classes.description}><FormattedMessage id="promotions.description" /></p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PromotionsPageHeader;
